import { createRouter, createWebHistory } from 'vue-router';
import { RouteRecordRaw } from 'vue-router';
import { RouterViewComponent } from '~packages/epk-front-shared/lib';
import { useRoutesFileSystem } from '~packages/filu';

import routes from './routes';

/*  */
const modulesPrefix = '../pages/';

const routesToUse = [
  ...routes,
  {
    path: '/__fs-js',
    component: RouterViewComponent,
    children: useRoutesFileSystem(
      import.meta.glob('../pages/**/index.js'),
      RouterViewComponent,
      modulesPrefix.length,
      '/index.js'.length
    ),
  },
  {
    path: '/__fs-ts',
    component: RouterViewComponent,
    children: useRoutesFileSystem(
      import.meta.glob('../pages/**/index.ts'),
      RouterViewComponent,
      modulesPrefix.length,
      '/index.ts'.length
    ),
  },
  {
    path: '/__extracts/:id/:scope',
    component: () => import('@/pages/Extract/ExtractPage.vue'),
  },
] as RouteRecordRaw[];

export default createRouter({
  history: createWebHistory(),
  routes: routesToUse,
  linkExactActiveClass: 'active',
});
